// Register the PWA service worker in production only (CRA public URL aware).

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }
  const publicUrl = process.env.PUBLIC_URL != null ? new URL(process.env.PUBLIC_URL, window.location.href) : window.location;
  if (publicUrl.origin !== window.location.origin) {
    return;
  }
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker
      .register(swUrl)
      .catch(() => {
        /* optional PWA */
      });
  });
}
